<template>
    <div v-if="hasGetData" class="sync-rule-box" :class="readOnly ? 'sync-rule-read' : ''">
        <ul class="sync-rule-desc">
            <li>
                <template v-if="!readOnly">{{ $t('开启同步后，') }}</template
                >{{ $t('企业微信创建的员工会自动同步至企点，企点中无法创建员工；') }}<br />{{ $t('同步每2小时进行一次，人员过多的情况下可能一天一次') }}
            </li>
            <li>{{ $t('当企业微信中的员工被删除后，') }}<span>{{ $t('企点中的员工和关联业务将被自动删除') }}</span></li>
            <li>{{ $t('从企业微信同步员工到企点时，为他们统一设置以下内容：') }}</li>
        </ul>

        <div class="sync-rule-params">
            <div class="sync-rule-label">{{ $t('权限角色') }}</div>
            <div class="sync-rule-content">
                <v-radio-group v-model="ruleType" vertical>
                    <v-radio v-if="!readOnly || (readOnly && ruleType === 1)" name="radio" :value="1"
                        >{{ $t('所有员工使用相同角色') }}
                        <a
                            v-if="isAllSameRole && allSomeRules.length === 0"
                            class="add-role-btn"
                            href="javascript:;"
                            @click="showRoleSelectPanel('all')"
                            >{{ $t('选择角色') }}</a
                        >
                    </v-radio>
                    <role-item
                        v-model="allSomeRules"
                        v-if="isAllSameRole && allSomeRules.length > 0"
                        @handleChange="showRoleSelectPanel('all')"
                    />
                    <v-radio v-if="!readOnly || (readOnly && ruleType === 2)" name="radio" :value="2" class="mt-17"
                        >{{ $t('不同部门员工使用不同角色') }}</v-radio
                    >
                    <div v-if="!isAllSameRole" class="select-different-rules">
                        <div class="select-different-rules-item item-title">
                            <div class="item-department">{{ $t('部门') }}</div>
                            <div class="item-rule">{{ $t('角色') }}</div>
                            <div class="item-del"></div>
                        </div>
                        <div v-for="(item, idx) in departRules" :key="idx" class="select-different-rules-item">
                            <div class="item-department">
                                <org-select
                                    class="readonly"
                                    mode="pop"
                                    :use-big-tree="true"
                                    :show-search="false"
                                    :show-result="false"
                                    :single="false"
                                    :selected="item.deps"
                                    :show-additional-footer="true"
                                    :use-arrow="false"
                                    :with-checkbox="true"
                                    :cust-fetch-tree="getDepTree"
                                    :maps="treeMaps"
                                    :dropdwon-placeholder="$t('请选择部门')"
                                    :res-txt="$t('$res等$num个部门')"
                                    subtitle=""
                                    @change="onChange"
                                    @confirm="onConfirm($event, idx)"
                                ></org-select>
                            </div>
                            <div class="item-rule">
                                <role-item v-model="item.roles" @handleChange="showRoleSelectPanel('depart', idx)" />
                                <role-select-panel
                                    v-model="showDiffRolePanel"
                                    :tips="$t('从企业微信同步员工后，将消耗角色所对应的套餐配额')"
                                    :selected-id-arr="selectedIdArr"
                                    :extra-req-params="extraReqParams"
                                    :set-package-disable="false"
                                    @confirm="selectDiffRules(arguments, idx)"
                                ></role-select-panel>
                            </div>
                            <div class="item-del">
                                <v-icon
                                    v-show="differentRules.length > 1"
                                    name="v-delete"
                                    @click="removeDifferentRule(idx)"
                                ></v-icon>
                            </div>
                        </div>
                        <div class="select-different-rules-item item-add-rules">
                            <span @click="differentRules.push({})"><v-icon name="v-add"></v-icon> {{ $t('添加部门') }}</span>
                        </div>
                    </div>
                    <div v-if="!isAllSameRole" class="item-info select-different-rules-default">
                        <div class="select-different-rules-default-title">
                            {{ $t('默认角色') }}
                            <span class="item-desc"> {{ $t('当以上角色不存在，或员工不在以上部门时，统一使用默认角色') }}</span>
                        </div>
                        <role-item v-model="defaultRules" @handleChange="showRoleSelectPanel('default')" />
                        <role-select-panel
                            v-model="showRolePanel"
                            :tips="$t('从企业微信同步员工后，将消耗角色所对应的套餐配额')"
                            :selected-id-arr="selectedIdArr"
                            :extra-req-params="extraReqParams"
                            :set-package-disable="false"
                            @confirm="selectDefaultRules"
                        ></role-select-panel>
                    </div>
                </v-radio-group>
            </div>
        </div>
        <div v-if="readOnly && sendMsgByTel" class="sync-rule-params">
            <div class="sync-rule-label">{{ $t('短信通知') }}</div>
            <div class="sync-rule-content">{{ $t('将企点账号和初始密码通过短信发送给员工') }}</div>
        </div>
        <div v-if="!readOnly" class="sync-rule-params">
            <div class="sync-rule-label">{{ $t('短信通知') }}</div>
            <div class="sync-rule-content">
                <v-checkbox v-model="sendMsgByTel" :label="$t('将企点账号和初始密码通过短信发送给员工')" />
                <div class="item-desc mgt-8">
                    {{ $t('如果员工在企业微信上未绑定手机号，则不发送短信') }}<br />
                    {{ $t('如果不发送短信，需要管理员在组织架构中为员工修改初始密码后，员工才能登录企点') }}
                </div>
            </div>
        </div>
        <role-select-panel
            v-model="isShowRolePanel"
            :tips="$t('从企业微信同步员工后，将消耗角色所对应的套餐配额')"
            :extra-req-params="extraReqParams"
            :selected-id-arr="selectedRoleIdArr"
            :set-package-disable="false"
            @confirm="onSelectRoles"
        ></role-select-panel>
    </div>
</template>

<script>
import OrgSelect from 'src/components/org-select';
import RoleSelectPanel from '@/components/role-select-panel';
import Gateway from '@/utils/Gateway';
import getSyncConfig from '@/cgi/getSyncConfig';
import getDepTree from '@/pages/mng/third_account/weworkCombine/api/getDepTree';
import RoleItem from '../../role-item/index';

export default {
    components: {
        RoleSelectPanel,
        RoleItem,
        OrgSelect
    },

    props: {
        isEdit: {
            type: Boolean,
            default: false
        },

        // 只展示不能编辑
        readOnly: {
            type: Boolean,
            default: false
        },

        ruleData: {
            type: Object,
            default() {
                return null;
            }
        }
    },

    data() {
        return {
            hasGetData: false,
            syncMode: 0,
            ruleType: 1,
            sendMsgByTel: true,

            // 请求获取角色列表接口额外添加的参数，创建员工时传opt为create，编辑员工时传入员工的kfext值
            extraReqParams: {
                opt: 'fromWework',
            },
            showRolePanel: false,
            showAllRolePanel: false,
            selecteshowRolePaneldIdArr: [],
            selectedIdArr: [],

            // 全部都用相同角色
            allSomeRules: [],

            // 没有选到的默认角色
            defaultRules: [],

            // 分部门角色列表
            showDiffRolePanel: false,
            differentRules: [{ deps: [], roles: [] }],

            // 部门选择框参数
            selectedDepart: [],

            // roleConfig: {},
            treeMaps: {
                value: 'id',
                children: 'deps'
            },

            isShowRolePanel: false,
            selectedRoleIdArr: [],
            currRoleType: '',
            currRoleIndex: 0,
            getDepTree
        };
    },

    computed: {
        departRules() {
            return this.differentRules.map(item => {
                let deps = [];

                if (item.deps && item.deps.length) {
                    deps = item.deps.map(d => {
                        return {
                            id: d.dep_id,
                            name: d.dep_name
                        };
                    });
                }

                return { ...item, deps };
            });
        },

        isAllSameRole() {
            return this.ruleType === 1;
        }
    },

    created() {
        if (this.ruleData) {
            this.handleData(this.ruleData);
            this.hasGetData = true;
        } else if (this.isEdit) {
            this.getSyncConfig();
        } else {
            this.hasGetData = true;
        }
    },

    methods: {
        // 企业微信通讯录同步配置获取
        getSyncConfig() {
            getSyncConfig()
                .then(res => {
                    this.handleData(res);
                    this.hasGetData = true;
                })
                .catch(() => {
                    this.hasGetData = true;
                });
        },

        handleData(res) {
            const { hasSyncRule, syncMode, syncRuleType, syncRule, defaultRoles, isAllSameRole, isSendMsg } = res;

            if (hasSyncRule) {
                this.syncMode = syncMode;
                this.ruleType = syncRuleType;

                if (isAllSameRole) {
                    this.allSomeRules = defaultRoles;
                } else {
                    this.defaultRules = defaultRoles;
                    this.differentRules = syncRule;
                }
                this.sendMsgByTel = isSendMsg;
            }
        },

        selectAllSomeRules(checkedItemArr) {
            this.allSomeRules = checkedItemArr.map(item => {
                return {
                    role_id: item.roleId,
                    role_name: item.roleName
                };
            });
        },

        selectDefaultRules(checkedItemArr) {
            this.defaultRules = checkedItemArr.map(item => {
                return { role_id: item.roleId, role_name: item.roleName };
            });
        },

        // 不同部门选择结果
        selectDiffRules(args, idx) {
            const tempArr = args[0].map(item => {
                return {
                    role_id: item.roleId,
                    role_name: item.roleName
                };
            });
            this.$set(this.differentRules[idx], 'roles', tempArr);
        },

        // 删除部门
        removeDifferentRule(idx) {
            if (this.differentRules.length > 1) {
                this.$delete(this.differentRules, idx);
            } else {
                this.$message.error(this.$t('最少填写一条部门角色信息'));
            }
        },

        // 部门选择树改变
        onChange() {
            // console.log('example onChange', data);
        },

        // 部门选择树确认
        onConfirm(data, idx) {
            const tempArr = data.map(item => {
                return {
                    dep_id: item.id,
                    dep_name: item.name
                };
            });
            this.$set(this.differentRules[idx], 'deps', tempArr);
        },

        // 部门选择树数据获取
        custFetchTreeAll(params) {
            const { isFirstFetch } = params;
            let defer;

            if (isFirstFetch) {
                defer = Gateway.get('/v1/wework/DepTree', {
                    depId: 1
                }).then(data => {
                    return {
                        allTreeData: [data]
                    };
                });
            } else {
                defer = Promise.resolve({ list: [] });
            }

            return defer;
        },

        showRoleSelectPanel(type, index) {
            let selectedRoleArr = [];

            if (type === 'all') {
                selectedRoleArr = this.allSomeRules;
            } else if (type === 'depart') {
                selectedRoleArr = this.differentRules[index].roles || [];
            } else if (type === 'default') {
                selectedRoleArr = this.defaultRules;
            }

            this.selectedRoleIdArr = selectedRoleArr.map(item => item.role_id);

            this.currRoleType = type;
            this.currRoleIndex = index;

            this.isShowRolePanel = true;
        },

        onSelectRoles(checkedItemArr) {
            const formatCheckedArr = checkedItemArr.map(item => {
                return {
                    role_id: item.roleId,
                    role_name: item.roleName
                };
            });

            if (this.currRoleType === 'all') {
                this.allSomeRules = formatCheckedArr;
            } else if (this.currRoleType === 'depart') {
                this.$set(this.differentRules[this.currRoleIndex], 'roles', formatCheckedArr);
            } else if (this.currRoleType === 'default') {
                this.defaultRules = formatCheckedArr;
            }
        },

        validate() {
            let isValid = true;

            const diffRuleDepCheck = this.differentRules.every(item => {
                return item.deps && item.deps.length;
            });

            const diffRuleRoleCheck = this.differentRules.every(item => {
                return item.roles && item.roles.length;
            });

            if (!this.isAllSameRole && !diffRuleDepCheck) {
                this.$message.error(this.$t('部门不能为空'));
                isValid = false;
            } else if (
                (this.isAllSameRole && this.allSomeRules.length === 0) ||
                (!this.isAllSameRole && !diffRuleRoleCheck)
            ) {
                this.$message.error(this.$t('权限角色不能为空'));
                isValid = false;
            } else if (!this.isAllSameRole && this.defaultRules.length === 0) {
                this.$message.error(this.$t('默认角色不能为空'));
                isValid = false;
            }

            return isValid;
        },

        getData() {
            const reqData = {
                send_msg_by_tel: this.sendMsgByTel ? 2 : 1,
                sync_rule_type: this.ruleType
            };

            if (this.isAllSameRole) {
                reqData.default_roles = this.allSomeRules;
            } else {
                reqData.sync_rule = this.differentRules;
                reqData.default_roles = this.defaultRules;
            }

            return reqData;
        }
    }
};
</script>
<style lang="less">
@import './sync-rule.less';
</style>
